export default __webpack_public_path__ + "static/media/5.703f3b65.png";